import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface ProcessStagedBookingPayloadTypes {
  payNow: boolean
  bookingNumber: string
  paymentMethod: string | null
  paymentMode: string
  travelerId: number | null
  newCard: boolean
  paymentType: string
}

export interface ProcessStagedBookingRequest
  extends Partial<AxiosRequestConfig> {
  params: ProcessStagedBookingPayloadTypes
}

export interface ProcessStagedBookingResponseData {
  isFirstLogin: boolean
  message?: string
  errorCode?: string
  status: number
  bookingNo?: string
  bookingId?: number
  bookingTotalAmount?: number
  paymentMethod?: string
  clientSecret?: string
}

export interface ProcessStagedBookingResponse extends AxiosResponse {
  data: ProcessStagedBookingResponseData
}

export function processStagedBookingApi(
  { params }: ProcessStagedBookingRequest,
  axiosInstance: AxiosInstance,
): Promise<ProcessStagedBookingResponse> {
  const url = `/booking/process-staged-booking-payment`

  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as Promise<ProcessStagedBookingResponse>
}
